


export const treeSelectedSitesActions = {
    setTreeSelectedSitesFleet({ commit }, payload) {
        commit('SET_TREE_SELECTED_SITES_FLEET', payload);
      }

};
